/* eslint-disable no-unused-vars */
import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@material-ui/core"
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
//import InfoOutlinedIcon from '@material-ui/icons/Info';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { currentDate} from '../../../../utils/currentDate'
import DialogTitle from '@material-ui/core/DialogTitle';
import CallToActionIcon from '@material-ui/icons/CallToAction';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import jwt from 'jwt-decode'

const useStyles = makeStyles(theme => ({
    value: {
        fontSize: 14,
        fontWeight: 600,
        color: colors.grey[900],
    },
    formValue: {
        fontSize: 20,
        fontWeight: 600,
        // flex: 1,
        color: colors.grey[900],
        border: 0,
        resize: 'none',
        overflow: 'hidden',
        padding: '-70px',
        backgroundColor: "#F4F6F8",
        maxWidth: '100%'
    },
    MuiTypographyH6: {
        // color: '#263238',
        fontSize: '18px',
        fontFamily: "Roboto",
        fontWeight: 800,
        lineHeight: "20px",
        letterSpacing: "-0.05px",
        color: colors.grey[900],
        backgroundColor: colors.lightBlue[300]
    },
    details: {
        color: colors.grey[900],
        backgroundColor: colors.lime[500],
        display: 'flex',
        justifyContent: 'flex-start',
        fontWeight: 500,
        textTransform: 'capitalize'
    },
}));

export const Review = ({ formIdValue, handleReveiw, handleClosePreview, handleToggleSnackBar, handleClickOpenQuery, handleCloseQuery, setOpenQuery, openQuery }) => {
    // export const Review = ({otherNames, formIdValue, fields, onhandleSubmit, handleClosePreview, handleToggleSnack}) => {
    const [open, setOpen] = React.useState(false);
    const [comment, setComment] = React.useState('');
    const [review, setReview] = React.useState('');
    const disabledValue = comment === '' || review === '';
    const classes = useStyles();
    const tokenValue = localStorage.getItem('value');
    const decoded = jwt(tokenValue)
    const reviewName = decoded.family_name +' '+ decoded.given_name || "Amos";
    const values = {"formID":formIdValue, "comment":comment, "status":review, "reviewer": reviewName, reviewDate:currentDate()}
    // console.log(values)
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (event) => {
        setComment(event.target.value);
    };

    const handleReviewChange = (event) => {
        setReview(event.target.value);
    };

    return (
        <div>
            <Button
                autoFocus
                // color="inherit"
                variant="contained"
                size="large"
                color="primary"
                // disabled={isSubmitting || !isValid && dirty}
                // type="submit"
                onClick={handleOpen}
            >
                Finish Form Review
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="customized-dialog-title" className={classes.MuiTypographyH6}>{"Complete Reveiw"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span className={classes.value}>Hi, <br /><br /> <li>Please complete your review with a comment and respective action below.<br /></li> <li>Please make sure that you have fully reveiwed all the information correctly.</li></span><br />
                        {/* <span className={classes.value}>{formIdValue}</span>   */}
                        <Button variant="contained" fullWidth className={classes.details}><CallToActionIcon />&nbsp;Select Action&nbsp;-&nbsp;<span>Choose to either Approve or Reject</span></Button>
                        <FormControl fullWidth component="fieldset">
                            {/* <FormLabel component="legend">Gender</FormLabel> */}
                            <RadioGroup required aria-label="review" name="review" value={review} onChange={handleReviewChange}>
                                <FormControlLabel value="APPROVED" control={<Radio />} label="Approve" />
                                <FormControlLabel value="REJECTED" control={<Radio />} label="Reject" />
                            </RadioGroup><br />
                            <TextField
                                id="outlined-multiline-flexible"
                                label={review === '' ? 'Comment here' : `Please leave a comment as to why you've ${review} below!`}
                                multiline
                                rowsMax={4}
                                value={comment}
                                onChange={handleChange}
                                variant="outlined"
                                name='comment'
                            />
                        </FormControl>
                        {/* <span className={classes.value}><textarea wrap="on" className={classes.formValue} value={comment}></textarea></span> */}
                        <br />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="secondary" variant="outlined">
                        Cancel
          </Button>
                    <Button onClick={() => {
                        handleReveiw(values);
                        // handleToggleSnackBar();
                        handleClose();
                        handleClosePreview();
                        handleCloseQuery();
                    }}
                        disabled={disabledValue}
                        type='submit' color="primary"
                        variant="contained" autoFocus>
                        {/* <Button onClick={()=>{onhandleSubmit(fields); handleClose(); handleClosePreview(); handleToggleSnack()}} type='submit' color="primary"  variant="contained" autoFocus> */}
            Submit
          </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default Review;